"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHighlightColorOptions = exports.useFontColorOptions = exports.isToolbarControlVisible = exports.isToolbarBlockVisible = exports.handlePopoverKeyboardNavigation = exports.getColorName = exports.findSelectedOptionIndex = exports.findPrevEnabledIndex = exports.findNextEnabledIndex = void 0;

var _emotionTheming = require("emotion-theming");

var _utils = require("../../utils");

var _constants = require("./constants");

var isToolbarControlVisible = function isToolbarControlVisible(control) {
  return control !== undefined && control !== false && !!control.showInToolbar;
};

exports.isToolbarControlVisible = isToolbarControlVisible;

var isToolbarBlockVisible = function isToolbarBlockVisible(toolbarItems, controls) {
  return controls.some(function (c) {
    return isToolbarControlVisible(toolbarItems[c]);
  });
};

exports.isToolbarBlockVisible = isToolbarBlockVisible;

var findPrevEnabledIndex = function findPrevEnabledIndex(enabledOptions, currentIndex) {
  for (var i = currentIndex - 1; i >= 0; i--) {
    if (!enabledOptions[i].disabled) {
      return i;
    }
  }

  return 0;
};

exports.findPrevEnabledIndex = findPrevEnabledIndex;

var findNextEnabledIndex = function findNextEnabledIndex(enabledOptions, currentIndex) {
  for (var i = currentIndex + 1; i < enabledOptions.length; i++) {
    if (!enabledOptions[i].disabled) {
      return i;
    }
  }

  return enabledOptions.length - 1;
};

exports.findNextEnabledIndex = findNextEnabledIndex;

var findSelectedOptionIndex = function findSelectedOptionIndex(options, selectedColor) {
  var highlightColorIndex = options.findIndex(function (option) {
    return option.value === selectedColor;
  });

  if (highlightColorIndex !== -1) {
    return highlightColorIndex;
  } else {
    return 0; // Set default index if no match found
  }
};

exports.findSelectedOptionIndex = findSelectedOptionIndex;

var handlePopoverKeyboardNavigation = function handlePopoverKeyboardNavigation(event, options, setIsPopoverOpen, highlightedOptionIndex, setHighlightedOptionIndex, focusPopoverMenuItemOnOpen) {
  // Get the index of the currently highlighted option in the options array
  var currentEnabledIndex;

  if (highlightedOptionIndex !== null) {
    currentEnabledIndex = options.findIndex(function (_, i) {
      return options.indexOf(options[i]) === highlightedOptionIndex;
    });
  } else {
    currentEnabledIndex = 0;
  }

  switch (event.key) {
    case _utils.EventKeys.TAB:
      setIsPopoverOpen(false);
      break;

    case _utils.EventKeys.ESCAPE:
      setIsPopoverOpen(false);
      break;

    case _utils.EventKeys.ARROW_LEFT:
      event.preventDefault();
      event.stopPropagation();
      setIsPopoverOpen(false);
      break;

    case _utils.EventKeys.ARROW_UP:
      event.preventDefault();

      if (highlightedOptionIndex === null) {
        var lastEnabledOptionIndex = options.length - 1;

        if (lastEnabledOptionIndex !== -1) {
          setHighlightedOptionIndex(options.indexOf(options[lastEnabledOptionIndex]));
        }
      } else {
        var newIndex = highlightedOptionIndex - 1 >= 0 ? highlightedOptionIndex - 1 : options.length - 1;
        setHighlightedOptionIndex(newIndex);
      }

      focusPopoverMenuItemOnOpen();
      break;

    case _utils.EventKeys.ARROW_DOWN:
      event.preventDefault();

      if (highlightedOptionIndex === null) {
        // set to first enabled option
        setHighlightedOptionIndex(0);
      } else {
        var _newIndex = highlightedOptionIndex + 1 < options.length ? highlightedOptionIndex + 1 : 0;

        setHighlightedOptionIndex(_newIndex);
      }

      focusPopoverMenuItemOnOpen();
      break;
  }

  return currentEnabledIndex;
};

exports.handlePopoverKeyboardNavigation = handlePopoverKeyboardNavigation;

var useFontColorOptions = function useFontColorOptions(localization) {
  var _ref, _localization$colorBl, _ref2, _localization$colorBl2, _ref3, _localization$colorGr, _ref4, _localization$colorPu, _ref5, _localization$colorRe, _ref6, _localization$colorYe;

  var _useTheme = (0, _emotionTheming.useTheme)(),
      selectors = _useTheme.selectors;

  var _toolbarFontColorPopo = _constants.toolbarFontColorPopoverDefaultProps.localization,
      colorBlackTitleText = _toolbarFontColorPopo.colorBlackTitleText,
      colorBlueTitleText = _toolbarFontColorPopo.colorBlueTitleText,
      colorGreenTitleText = _toolbarFontColorPopo.colorGreenTitleText,
      colorPurpleTitleText = _toolbarFontColorPopo.colorPurpleTitleText,
      colorRedTitleText = _toolbarFontColorPopo.colorRedTitleText,
      colorYellowTitleText = _toolbarFontColorPopo.colorYellowTitleText;
  var options = [{
    title: (_ref = (_localization$colorBl = localization === null || localization === void 0 ? void 0 : localization.colorBlackTitleText) !== null && _localization$colorBl !== void 0 ? _localization$colorBl : colorBlackTitleText) !== null && _ref !== void 0 ? _ref : 'Black',
    value: selectors.color('neutral100')
  }, {
    title: (_ref2 = (_localization$colorBl2 = localization === null || localization === void 0 ? void 0 : localization.colorBlueTitleText) !== null && _localization$colorBl2 !== void 0 ? _localization$colorBl2 : colorBlueTitleText) !== null && _ref2 !== void 0 ? _ref2 : 'Blue',
    value: selectors.color('primary70')
  }, {
    title: (_ref3 = (_localization$colorGr = localization === null || localization === void 0 ? void 0 : localization.colorGreenTitleText) !== null && _localization$colorGr !== void 0 ? _localization$colorGr : colorGreenTitleText) !== null && _ref3 !== void 0 ? _ref3 : 'Green',
    value: selectors.color('green70')
  }, {
    title: (_ref4 = (_localization$colorPu = localization === null || localization === void 0 ? void 0 : localization.colorPurpleTitleText) !== null && _localization$colorPu !== void 0 ? _localization$colorPu : colorPurpleTitleText) !== null && _ref4 !== void 0 ? _ref4 : 'Purple',
    value: selectors.color('purple70')
  }, {
    title: (_ref5 = (_localization$colorRe = localization === null || localization === void 0 ? void 0 : localization.colorRedTitleText) !== null && _localization$colorRe !== void 0 ? _localization$colorRe : colorRedTitleText) !== null && _ref5 !== void 0 ? _ref5 : 'Red',
    value: selectors.color('red70')
  }, {
    title: (_ref6 = (_localization$colorYe = localization === null || localization === void 0 ? void 0 : localization.colorYellowTitleText) !== null && _localization$colorYe !== void 0 ? _localization$colorYe : colorYellowTitleText) !== null && _ref6 !== void 0 ? _ref6 : 'Yellow',
    value: selectors.color('yellow70')
  }];
  return options;
};

exports.useFontColorOptions = useFontColorOptions;

var useHighlightColorOptions = function useHighlightColorOptions(localization) {
  var _ref7, _localization$noHighl, _ref8, _localization$colorBl3, _ref9, _localization$colorGr2, _ref10, _localization$colorPu2, _ref11, _localization$colorRe2, _ref12, _localization$colorYe2;

  var _useTheme2 = (0, _emotionTheming.useTheme)(),
      selectors = _useTheme2.selectors;

  var _toolbarHighlightPopo = _constants.toolbarHighlightPopoverDefaultProps.localization,
      noHighlightText = _toolbarHighlightPopo.noHighlightText,
      colorBlueTitleText = _toolbarHighlightPopo.colorBlueTitleText,
      colorGreenTitleText = _toolbarHighlightPopo.colorGreenTitleText,
      colorPurpleTitleText = _toolbarHighlightPopo.colorPurpleTitleText,
      colorRedTitleText = _toolbarHighlightPopo.colorRedTitleText,
      colorYellowTitleText = _toolbarHighlightPopo.colorYellowTitleText;
  var options = [{
    title: (_ref7 = (_localization$noHighl = localization === null || localization === void 0 ? void 0 : localization.noHighlightText) !== null && _localization$noHighl !== void 0 ? _localization$noHighl : noHighlightText) !== null && _ref7 !== void 0 ? _ref7 : 'No highlight',
    value: selectors.color('neutral0')
  }, {
    title: (_ref8 = (_localization$colorBl3 = localization === null || localization === void 0 ? void 0 : localization.colorBlueTitleText) !== null && _localization$colorBl3 !== void 0 ? _localization$colorBl3 : colorBlueTitleText) !== null && _ref8 !== void 0 ? _ref8 : 'Blue',
    value: selectors.color('primary70')
  }, {
    title: (_ref9 = (_localization$colorGr2 = localization === null || localization === void 0 ? void 0 : localization.colorGreenTitleText) !== null && _localization$colorGr2 !== void 0 ? _localization$colorGr2 : colorGreenTitleText) !== null && _ref9 !== void 0 ? _ref9 : 'Green',
    value: selectors.color('green70')
  }, {
    title: (_ref10 = (_localization$colorPu2 = localization === null || localization === void 0 ? void 0 : localization.colorPurpleTitleText) !== null && _localization$colorPu2 !== void 0 ? _localization$colorPu2 : colorPurpleTitleText) !== null && _ref10 !== void 0 ? _ref10 : 'Purple',
    value: selectors.color('purple70')
  }, {
    title: (_ref11 = (_localization$colorRe2 = localization === null || localization === void 0 ? void 0 : localization.colorRedTitleText) !== null && _localization$colorRe2 !== void 0 ? _localization$colorRe2 : colorRedTitleText) !== null && _ref11 !== void 0 ? _ref11 : 'Red',
    value: selectors.color('red70')
  }, {
    title: (_ref12 = (_localization$colorYe2 = localization === null || localization === void 0 ? void 0 : localization.colorYellowTitleText) !== null && _localization$colorYe2 !== void 0 ? _localization$colorYe2 : colorYellowTitleText) !== null && _ref12 !== void 0 ? _ref12 : 'Yellow',
    value: selectors.color('yellow70')
  }];
  return options;
};

exports.useHighlightColorOptions = useHighlightColorOptions;

var getColorName = function getColorName(hexColor, options) {
  var normalizedHexColor = hexColor.toLowerCase();
  var option = options.find(function (option) {
    return option.value === normalizedHexColor;
  });
  return option ? option.title : 'unknown';
};

exports.getColorName = getColorName;